import { Pipe, PipeTransform } from '@angular/core';
import { GlobalService } from '@common/global';
@Pipe({
  name: 'isOwner'
})
export class IsOwnerPipe implements PipeTransform {
  constructor( private _global: GlobalService) { }
  transform(value: unknown, ...args: unknown[]): unknown {
    //return null;
    return this._global.isOwner(value);
  }

}
